import React from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';

class EmptyRowsView extends React.Component {
  render() {
    return (<div style={{
      textAlign: "center"
    }}><font color="lightGrey">
        <h1>    No Data </h1>
      </font></div>);
  }
}

export default class Table extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sortColumn: null, sortDirection: null,
      //rows: this.props.data || [],
      filters: {},
      selectedIndexes: [],
      selectedObjects: []
    };
    this.handleTableFilterChange = this.handleTableFilterChange.bind(this);
    this.getTableRows = this.getTableRows.bind(this);
    this.getTableLength = this.getTableLength.bind(this);
    this.tableRowGetter = this.tableRowGetter.bind(this);
    this.onTableClearFilters = this.onTableClearFilters.bind(this);
    this.handleTableGridSort = this.handleTableGridSort.bind(this);
    this.getValidTableFilterValues = this.getValidTableFilterValues.bind(this);
    this.getTableData = this.getTableData.bind(this);
    this.onTableRowsSelected = this.onTableRowsSelected.bind(this);
    this.onTableRowsDeselected = this.onTableRowsDeselected.bind(this);    

  }

  handleTableFilterChange(filter) {
    const { dispatchSetUiState, uiState } = this.props;
    let newFilters = Object.assign({}, uiState.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    dispatchSetUiState({
      filters: newFilters,
      selectedIndexes: [],
      selectedObjects: []
    });
  }

  handleTableGridSort(sortColumn, sortDirection) {
    const { dispatchSetUiState } = this.props;
    dispatchSetUiState({ sortColumn: sortColumn, sortDirection: sortDirection });
  }

  getTableData() {
    return this.props.data || [];
  }

  getTableRows() {
    const { uiState } = this.props;
    uiState.rows = this.getTableData();
    return Data.Selectors.getRows(uiState);
  }

  getTableLength() {
    return this.getTableRows().length;
  }

  tableRowGetter(rowIdx) {
    let rows = this.getTableRows();
    return rows[rowIdx];
  }

  onTableClearFilters() {
    const { dispatchSetUiState } = this.props;
    dispatchSetUiState({ filters: {} });
  }

  getValidTableFilterValues(columnId) {
    let values = this.getTableData().map(r => r[columnId]);
    return values.filter((item, i, a) => { return i === a.indexOf(item); });
  }

  onTableRowsSelected(rows) {
    const { dispatchSetUiState, uiState } = this.props;
    dispatchSetUiState({
      selectedIndexes: uiState.selectedIndexes.concat(rows.map(r => r.rowIdx)),
      selectedObjects: uiState.selectedObjects.concat(rows.map(r => r.row))
    });
  }

  onTableRowsDeselected(rows) {
    const { dispatchSetUiState, uiState } = this.props;
    let rowIndexes = rows.map(r => r.rowIdx);
    let rowIds = rows.map(r => r.row._id);
    dispatchSetUiState({
      selectedIndexes: uiState.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1),
      selectedObjects: uiState.selectedObjects.filter(obj => rowIds.indexOf(obj._id) === -1)
    });
  }

  render() {

    let { uiState, dispatchSetUiState, columns } = this.props;
    let { selectedIndexes } = uiState;

    return (
      <div style={{ width: "100%" }}>
        <ReactDataGrid
          onGridSort={this.handleTableGridSort}
          columns={columns}
          rowGetter={this.tableRowGetter}
          rowsCount={this.getTableLength()}
          toolbar={<Toolbar filterRowsButtonText="Query Rows" enableFilter={true} />}
          onAddFilter={this.handleTableFilterChange}
          onClearFilters={this.onTableClearFilters}
          getValidFilterValues={this.getValidTableFilterValues}
          emptyRowsView={EmptyRowsView}
          minHeight={640}
          rowSelection={{
            showCheckbox: true,
            enableShiftSelect: true,
            onRowsSelected: this.onTableRowsSelected,
            onRowsDeselected: this.onTableRowsDeselected,
            selectBy: {
              indexes: selectedIndexes || []
            }
          }}
        />
      </div>
    );
  }
}

Table.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  uiState: PropTypes.object,
  dispatchSetUiState: PropTypes.func,
};

Table.defaultProps = {
  onRowsSelected: () => true,
  onRowsDeselected: () => true
};


// WEBPACK FOOTER //
// ./src/components/Table/TableV2.js